export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProfileUpdate.vue?vue&type=template&id=5acf1b08&"


//////////////////
// WEBPACK FOOTER
// ./src/views/ProfileUpdate.vue?vue&type=template&id=5acf1b08&
// module id = 532
// module chunks = 6